export default "__VITE_ASSET__fvkO36Tv__"